import { render } from "./ConfirmationInscriptionPage.vue?vue&type=template&id=3af099e9"
import script from "./ConfirmationInscriptionPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationInscriptionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__